import React from 'react';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

export interface PhaseOptionControl {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

type PaintOptionControl = Omit<PhaseOptionControl, 'label'>;

export function paintOptionControls(
  job:
    | { hasExteriorOptions?: boolean; hasInteriorOptions?: boolean }
    | null
    | undefined,
  controls: { exterior: PaintOptionControl; interior: PaintOptionControl },
): PhaseOptionControl[] {
  return [
    ...(job?.hasExteriorOptions
      ? [{ label: 'Paint Exterior Options', ...controls.exterior }]
      : []),
    ...(job?.hasInteriorOptions
      ? [{ label: 'Paint Interior Options', ...controls.interior }]
      : []),
  ];
}

interface PhaseOptionsSectionProps {
  prompt: string;
  options: PhaseOptionControl[];
  supplementalContent?: React.ReactNode;
  divided?: boolean;
}

export function PhaseOptionsSection({
  prompt,
  options,
  supplementalContent,
  divided = false,
}: PhaseOptionsSectionProps): React.ReactElement {
  return (
    <Box
      mt={3}
      pt={divided ? 2 : 0}
      borderTop={divided ? '1px solid #e0e0e0' : undefined}
    >
      <Typography variant={divided ? 'body1' : 'body2'} gutterBottom>
        {prompt}
      </Typography>
      <Box display="flex" flexWrap="wrap" mt={divided ? 2 : 0}>
        {options.map(option => (
          <FormControlLabel
            key={option.label}
            control={
              <Checkbox
                checked={option.checked}
                onChange={event => option.onChange(event.target.checked)}
                disabled={option.disabled}
                color="primary"
              />
            }
            label={option.label}
          />
        ))}
      </Box>
      {supplementalContent}
    </Box>
  );
}
